<template>
    <div class="p-6">
        <button class="flex justify-between gap-4 w-full" @click="isToggled = !isToggled">
            <span class="uppercase font-mono leading-none text-md">{{ props.label }}</span>
            <PlusIcon class="size-6" aria-hidden="true" v-if="!isToggled" />
            <MinusIcon class="size-6" aria-hidden="true" v-if="isToggled" />
        </button>
        <div class="grid gap-2 pt-6" v-if="isToggled">
            <button
                @click.prevent="toggleOption(option.key)"
                class="flex gap-2 items-center justify-start text-left"
                v-for="option in options"
                :key="option.key"
            >
                <span class="size-3 border border-blue rounded-xl block" :class="{ '!bg-blue': modelValue.includes(option.key) }"></span>
                <span v-html="option.label" class="uppercase"></span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { PlusIcon, MinusIcon } from "@heroicons/vue/20/solid";

const props = defineProps({
    modelValue: {
        type: Array,
        default: () => [],
    },
    options: {
        type: Array,
        required: true,
    },
    label: {
        type: String,
        default: "Filter",
    },
});

const isToggled = ref(true);

const emit = defineEmits(["update:modelValue"]);

function toggleOption(optionId) {
    const current = [...props.modelValue];
    const index = current.indexOf(optionId);

    if (index > -1) {
        current.splice(index, 1);
    } else {
        current.push(optionId);
    }

    emit("update:modelValue", current);
}
</script>
